export default "__VITE_ASSET__LeiOc5dV__"